// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1Jx9M","resendInfoText":"OnGoingPaymentBox_resendInfoText__3DVHP"};